// extracted by mini-css-extract-plugin
export default {"close":"_8Nb_y"};